<template>
    <div v-if="data.list.length > 0">
        <h4 class="pd-l-10 pd-r-10 fz-20 fw-7 mg-t-20">{{ data.title }}</h4>
        <div class="horizontal-scroll-list hide-native-scroll hz-scroll-ac mg-t-20">
            <CircularTileImage 
                v-for="item in data.list"
                :data="item"
                :key="item.id"
                class="item circular-item"
            >
            </CircularTileImage>
        </div>
    </div>
</template>

<script>
    
    import CircularTileImage from "@/components/CircularTileImage.vue";

    export default {
        name : 'HorizontalScrollListCircular',
        components : {
            CircularTileImage : CircularTileImage,
        },
        props : {
            data : Object
        },
        data : function () {
            return {}
        },
        methods : {}
    }
</script>

<style>
    .hz-scroll-ac .circular-item{
        width: 100px;
    }
    .hz-scroll-ac .item:first-child{
        margin-left: 10px;
    }
    .hz-scroll-ac .item:last-child{
        margin-right: 10px;
    }
    .hz-scroll-ac .circular-item .img{
        width: 100px;
        height: 100px;
        border-radius: 50%;
        background-size: cover;
        background-position: center;
    }
</style>